import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, Output, EventEmitter, Input, OnDestroy } from '@angular/core';
import { WbService } from './wb.service';
import { WsService } from '../utils/network/ws.service';
import {SessionManagerService} from "./services/session/session-manager.service";
import {RecordingManagerService} from "./services/recording/recording-manager.service";

import {OnWbStateCallback} from "./services/session/session-manager";
import {OnRecording} from "./services/recording/recording-manager";
import {LayoutManagerService} from "./services/layout/layout-manager.service";
import { environment } from '../../environments/environment';
import {PermissionsManagerService} from "./services/permissions/permissions-manager.service";
import {LogService} from "./services/log/log.service";

declare var LZString;
export interface OnResize{
    getResizeTopOffset();
    onResize();
}
declare var $;
export abstract class WhiteBoardComponent implements AfterViewInit, OnInit, OnWbStateCallback, OnResize, OnDestroy{
    
    @Output() change = new EventEmitter();
    @Output() onCurrentState = new EventEmitter();
    @Input() board;
    /*
@Input() pageId;
    @Input() sessionId;
    @Input() boardId;
    @Input() history;
  @Input() canGoBack;
  @Input() topLayout;
  @Input() column;
  */
    constructor(protected logService: LogService, protected wbService: WbService, protected sessionManager: SessionManagerService, protected layoutServiceManager:LayoutManagerService, protected permissionsManager: PermissionsManagerService) { }
    showFile(f){}
    getResizeTopOffset(){
        
        var topOffset = 0;
       
    //    topOffset=$("#wb-status").height();
      //  if (!topOffset)
        topOffset = 40;
        if (this.layoutServiceManager.isVideosWb()){
            topOffset += $("#videos")&&$("#videos").length>0?$("#videos").height():0;
        }
        
        return topOffset;
    }
    getResizeBottomOffset(){
return $("footer")&&$("footer").length>0?$("footer").height():0;
    }
    ngAfterViewInit() {
        this.wbService.registerOnResize(this);
         this.wbService.registerOnFileCallback(this);
        this.onViewReady();
    }
    emitChanged(o){
        if (!this.permissionsManager.canUseTools()){
            return;
        }
        console.log("emitting change")
        if (!o || !this.board){
            console.error("Something is not quite right...", this);
            return;
        }
        this.change.emit({state: o, board: this.board});
        
        var state = JSON.stringify(this.getCurrentState());
        let d = LZString.compressToUTF16(state);
        console.log("Will send "+d.length);
        if (d.length>environment.wbStateSize){
            this.wbService.wbStateLimitReached();
        }else{
            this.sessionManager.previousStates[this.board.id] = true;
        }
}
getId(){
    return this.board.id;
}
ngOnDestroy(){
    console.log("Will unregister wb "+this.getId());
    this.sessionManager.unregisterWbStateCallback(this);
    this.wbService.unregisterOnresizeCallback(this);
    this.wbService.unregisterOnFileCallback(this);
}
 onSetCurrentPageState(state, pageId){
     console.log("Will check current page ", this.board);
     console.log("Current page state is ", state)
     if (this.board.pageId != pageId)return;
     if (state && state[0]!="@")
     this.onCurrentPageState(JSON.parse(state), pageId);
 }
    ngOnInit() {
        this.onReady();
        this.sessionManager.registerWbStateCallback(this);

    }

    getCurrentPageState(){
       // var s = this.getCurrentState();
       // console.log("Got current state for update ", s);
       
        var s = JSON.stringify(this.getCurrentState());
    
        let d = LZString.compressToUTF16(s);
        return {currentState: d, pageId: this.board.pageId};
    }
    onRecordingPageStateStored(pageId, recordId){
        
    }
    clearStates(){
        
    }
    abstract onReady();
    abstract onViewReady();
    abstract onState(state, pageId);
    abstract getWbType();
    abstract onCurrentPageState(state, pageId);
    abstract onResize();
    getCurrentState(){
        
    }
        
    
}


// WEBPACK FOOTER //
// /app/src/app/wb/white-board.component.ts